import { UserRoles } from '@equifinance/shared';
import { useUsersByPermissionTypes } from '../../hooks/useInternalUsers';

export const useUnderwriters = () => {
  const { internalUsers, setInternalUsers, fetchInternalUsers } = useUsersByPermissionTypes(UserRoles.UNDERWRITER);

  return {
    underwriters: internalUsers,
    setUnderwritersData: setInternalUsers,
    fetchUnderwriters: fetchInternalUsers,
  };
};
